import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { BorderedBlock } from "../../../../../../features/common-attributes/components/bordered-block/bordered-block.component";
import { SelectField } from "../../../../../../features/forms/fields/select-field/select-field.component";
import { RichTextField } from "../../../../../../features/forms/fields/rich-text-field/components/rich-text-field/rich-text-field.component";
import { getMarketingChannelOptions } from "../../../../../../redux/actions/executionBriefListActions";
import { selectMarketingChannelResults } from "../../../../../../redux/selectors/commonSelectors";

import { CbTemplateControlMarketingChannelsProps } from "./cb-template-control-marketing-channels.props";

export const CbTemplateControlMarketingChannels = (
  props: CbTemplateControlMarketingChannelsProps
) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getMarketingChannelOptions());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const marketingChannelsList = useSelector(selectMarketingChannelResults);
  const marketingChannelsOptions = marketingChannelsList.map((channel) => ({
    value: channel.id,
    label: channel.name,
  }));

  return (
    <>
      <BorderedBlock>
        <SelectField
          form={props.form}
          label="Marketing Channels"
          multiple
          name="marketingChannels"
          options={marketingChannelsOptions}
          placeholder="Select Marketing Channels"
          required={props.isRequired ?? true}
          userPermissions={props.userPermissions}
        />
      </BorderedBlock>
      <BorderedBlock>
        <RichTextField
          form={props.form}
          label="Other Marketing Channels"
          name="otherMarketingChannels"
          userPermissions={props.userPermissions}
          withAdd
        />
      </BorderedBlock>
    </>
  );
};
